import { FixedSizeGrid } from "react-window";
import { useEvent } from "../../../lib/hooks/useEvent";
import { forwardRef, useRef, useState, useEffect } from "react";
import { handleCheck } from "../../../lib/utils/stencilUtils";
import { useStencils } from "../../../lib/hooks/useStencils";
import { useStencilWeeks } from "../../../lib/hooks/useStencilWeeks";

const StencilGrid = forwardRef(
  (
    {
      setIsSelected,
      isSelected,
      setSelectedStencil,
      selectedStencil,
      setKeywords,
      keywords,
    },
    ref
  ) => {
    const { event } = useEvent();
    const { stencils, setStencils } = useStencils();
    const { stencilWeeks, setStencilWeeks } = useStencilWeeks();

    // const containerRef = useRef(null);
    // const [width, setWidth] = useState(0);

    // useEffect(() => {
    //   const observer = new ResizeObserver((entries) => {
    //     if (entries[0]) {
    //       setWidth(entries[0].contentRect.width);
    //     }
    //   });
    //   if (containerRef.current) {
    //     observer.observe(containerRef.current);
    //   }
    //   return () => observer.disconnect();
    // }, []);

    // Selected a stencil, now display it and its information on the right
    const handleClick = (stencil) => {
      if (selectedStencil === stencil) {
        setSelectedStencil(null);
        setIsSelected(false);
      } else {
        setSelectedStencil(stencil);
        setIsSelected(true);
      }
    };

    const columnCount = isSelected ? 3 : 4;
    const columnWidth = isSelected ? 226 : 256;
    const rowHeight = 290;
    const width = isSelected ? 695 : 1010;
    const height = 600;

    const rowCount = Math.ceil(keywords.length / columnCount);

    const Cell = ({ columnIndex, rowIndex, style }) => {
      const index = rowIndex * columnCount + columnIndex;
      const stencil = keywords[index];

      if (!stencil) return null;

      return (
        <div
          style={{
            ...style,
            paddingTop: 10,
            boxSizing: "border-box",
            height: "72.7vh",
          }}
        >
          {" "}
          {stencil && (
            <div
              style={{
                background: "#f4f4f4",
                borderRadius: 8,
                height: "100%",
                textAlign: "center",
              }}
            >
              <div
                key={stencil.id}
                className={`card ${
                  selectedStencil === stencil
                    ? `selected-stencil`
                    : `unselected-stencil`
                }`}
                style={{ margin: "10px", width: "33vh" }}
              >
                <button
                  style={{ border: "none", backgroundColor: "white" }}
                  onClick={() => handleClick(stencil)}
                >
                  <img
                    key={stencil.image_name}
                    src={`/api/stencils/files/${stencil.image_name}`}
                    alt={stencil.name}
                    width={100}
                  />
                  <hr />
                  <p>
                    {stencil.id} {stencil.name}
                  </p>
                </button>
                <div style={{ textAlign: "center" }}>
                  {!!event?.isActive && !stencil.archived && (
                    <form
                      key={`${stencil.id}`}
                      id={`${stencil.id}-check`}
                      style={{ display: "inline-block" }}
                    >
                      {[...Array(event?.num_weeks)].map((_, index) => {
                        return (
                          <label key={index + 1}>
                            <input
                              id={`${stencil.id}week${index + 1}`}
                              type="checkbox"
                              style={{ margin: "10px" }}
                              checked={
                                stencil[`isSelectedWeek${index + 1}`] === 1
                              }
                              onChange={() =>
                                handleCheck(
                                  stencil,
                                  index + 1,
                                  setSelectedStencil,
                                  selectedStencil,
                                  setKeywords,
                                  stencils,
                                  setStencils,
                                  stencilWeeks,
                                  setStencilWeeks
                                )
                              }
                            />
                            W{index + 1}
                          </label>
                        );
                      })}
                    </form>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    return (
      <FixedSizeGrid
        ref={ref}
        columnCount={columnCount}
        columnWidth={columnWidth}
        height={height}
        rowCount={rowCount}
        rowHeight={rowHeight}
        width={width}
        className="scroll-stencils"
      >
        {Cell}
      </FixedSizeGrid>
    );
  }
);

export default StencilGrid;
